<div class="PGChat bg-white">
    @if (!isLoggedIn) {
        <div class="PGChat-Login">
            @if (authorizationToken == null) {
                <div class="form-group mb-3">
                    <label>
                        <b>{{ 'pg-customer-care.guest-name' | locTranslate }}</b>
                    </label>
                    <input class="form-control" [(ngModel)]="unathorizedName" (keyup)="onUnathorizedNameKeyUp($event)"/>
                </div>
                <button class="btn btn-primary btn-block" [disabled]="!canUnauthorizedLogIn()" (click)="unauthorizedLogIn()">{{ 'pg-customer-care.login-as-guest' | locTranslate }}</button>
            }
        </div>
    }
    @if (isWaiting()) {
        <div class="PGChat-Waiting">
            @if (chatBookingData != null) {
                <div class="text-muted text-center px-3 mb-3">
                    @if (!isChatBookingPast) {
                        <span>{{ 'pg-customer-care.booking-start' | locTranslate }}</span>
                    }
                    @if (isChatBookingPast) {
                        <span>{{ 'pg-customer-care.booking-start-past' | locTranslate }}</span>
                    }
                    <br/>
                    <span>{{chatBookingData.from | locFormat:'date'}} {{ 'pg-customer-care.booking-start-at' | locTranslate }} {{chatBookingData.from | locFormat:'time'}}</span>
                </div>
            }
            @if (chatBookingData == null) {
                <div class="text-muted text-center">
                    @if (customerCareAvailability == 0) {
                        <h4 class="px-3 mb-3">{{ 'pg-customer-care.no-operator' | locTranslate }}</h4>
                        <div class="px-3 mb-3">{{ 'pg-customer-care.no-operator-try-later' | locTranslate }}
                            @if (hasCustomerCareBooking) {
                                <span> {{ 'pg-customer-care.operator-or' | locTranslate }}<br/>
                                    <button class="btn btn-link p-0" (click)="customerCareBookingRequest.emit()">{{ 'pg-customer-care.book-customer-care' | locTranslate }}</button>
                                </span>
                            }
                        </div>
                    }
                    @if (customerCareAvailability > 0) {
                        <h4 class="px-3 mb-3">{{ 'pg-customer-care.has-operator' | locTranslate }}</h4>
                        <div class="px-3 mb-3">{{ 'pg-customer-care.has-operator-please-wait' | locTranslate }}
                            @if (waitTimedOut) {
                                <span class="pg-animation-fadein"> {{ 'pg-customer-care.operator-or' | locTranslate }}<br/>
                                    <button class="btn btn-link p-0" (click)="customerCareBookingRequest.emit()">{{ 'pg-customer-care.book-customer-care' | locTranslate }}</button>
                                </span>
                            }
                        </div>
                    }
                </div>
            }
            <app-pg-loading></app-pg-loading>
        </div>
    }
    @if (!isWaiting()) {
        @if (hasAccessError) {
            <div class="text-danger">ERROR</div>
        }
        @if (!hasAccessError) {
            <div class="PGChat-Outer">
                @if (callChannel != null) {
                    <div class="PGChat-Call bg-white">
                        <app-pg-call [callToken]="callToken" [callChannel]="callChannel" [callURL]="callURL"></app-pg-call>
                    </div>
                }
                @if (callChannel == null) {
                    <div class="PGChat-Inner">
                        <div class="PGChat-CurrentChannel">
                            @if (channels[getCurrentChannel()]; as channel) {
                                <div class="PGChat-CurrentChannel-Content">
                                    @if (channel.status != null) {
                                        <div class="PGChat-CurrentChannel-Content-Main">
                                            <div #messagesElement class="PGChat-CurrentChannel-Content-Main-Messages py-1 px-2">
                                                @for (message of channel.status.messages; track message; let i = $index) {
                                                    @if (hasMessageDate(channel.status.messages, i)) {
                                                        <div class="text-muted border-bottom mb-2">
                                                            <small class="text-muted">{{ getMessageDate(message) }}</small>
                                                        </div>
                                                    }
                                                    <div class="mb-2">
                                                        @if (hasMessageUserAndTime(channel.status.messages, i)) {
                                                            <div>
                                                                <b class="me-2">{{ getUserName(message.from) }}</b>
                                                                <small class="text-muted">{{ getMessageTime(message) }}</small>
                                                            </div>
                                                        }
                                                        <div>
                                                            <span class="PGChat-CurrentChannel-Content-Main-Messages-Content">{{ message.content }}</span>
                                                        </div>
                                                    </div>
                                                }
                                            </div>
                                            <div class="PGChat-CurrentChannel-Content-Main-Input p-1 border-top">
                                                <input class="form-control form-control-sm" [(ngModel)]="editMessageText" (keyup)="onEditMessageTextKeyUp($event)"/>
                                            </div>
                                        </div>
                                    }
                                </div>
                            }
                        </div>
                    </div>
                }
            </div>
        }
    }
</div>
